<template>
  <div
    class="tw-bg-dark-teal tw-text-center tw-text-white tw-py-3 tw-z-[200] tw-text-[20px] xl:tw-text-[32px]"
  >
    New patient pricing available <strong>right now</strong> only!
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

</style>